<div class="automation-dialog">

  <!-- Header -->
  <div class="dialog-header">
  <div>
    <h2>Automation Process Detail</h2><br>

    <div class="header-info">
      <span class="label">Automation Template Name:</span>
      <span class="value">{{ aiAutomationTemplateName }}</span>
    </div>

    <div class="header-info">
      <span class="label">Attempts:</span>
      <span class="value">{{ attempts }}</span>
    </div>
  </div>

  <button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

  <!-- Templates -->
  <div class="section-title">TEMPLATES RUN</div>

  <div class="template-item">
    <div class="template-left">
      <div class="icon blue" *ngIf="isFieldProcessed==true">
        <mat-icon>description</mat-icon>
      </div>

      <div class="icon yellow" *ngIf="isFieldProcessed==false">
        <mat-icon>help_outline</mat-icon>
      </div>

      <div>
        <div class="title">Field template</div>
        <div class="subtitle">{{fieldTemplateName}}</div>
      </div>
    </div>

    <span *ngIf="isFieldProcessed==true" class="badge success">Ran</span>
    <span *ngIf="isFieldProcessed==false" class="badge pending">Pending</span>
  </div>

  <div class="template-item">
    <div class="template-left">
      <div class="icon blue" *ngIf="isReferralProcessed==true">
        <mat-icon>description</mat-icon>
      </div>

      <div class="icon yellow" *ngIf="isReferralProcessed==false">
        <mat-icon>help_outline</mat-icon>
      </div>

      <div>
        <div class="title">Qualifying template</div>
        <div class="subtitle">{{referralTemplateName}}</div>
      </div>
    </div>

    <span *ngIf="isReferralProcessed==true" class="badge success">Ran</span>
    <span *ngIf="isReferralProcessed==false" class="badge pending">Pending</span>
  </div>

  <div class="template-item">
    <div class="template-left">
     <div class="icon blue" *ngIf="isPromptProcessed==true">
        <mat-icon>description</mat-icon>
      </div>

      <div class="icon yellow" *ngIf="isPromptProcessed==false">
        <mat-icon>help_outline</mat-icon>
      </div>

      <div>
        <div class="title">Question template</div>
        <div class="subtitle">{{promptTemplateName}}</div>
      </div>
    </div>

    <span *ngIf="isPromptProcessed==true" class="badge success">Ran</span>
    <span *ngIf="isPromptProcessed==false" class="badge pending">Pending</span>
  </div>

  <!-- Status -->
   <div class="section-title mt-20">PROCESS STATUS</div>

  <div class="status-wrapper">

    <div class="status-item">
      <div class="circle done" *ngIf="isContentProcessed==true">
        <mat-icon>check</mat-icon>
      </div>
       <div class="circle progress" *ngIf="isContentProcessed==false">
        <mat-icon>autorenew</mat-icon>
      </div>
      <div class="status-title">OCR</div>
      <div *ngIf="isContentProcessed==true" class="status-text done-text">Done</div>
      <div *ngIf="isContentProcessed==false" class="status-text progress-text">Pending</div>
    </div>

    <div class="line done-line"></div>

    <div class="status-item">
       <div class="circle done" *ngIf="isFieldProcessed==true">
        <mat-icon>check</mat-icon>
      </div>
       <div class="circle progress" *ngIf="isFieldProcessed==false">
        <mat-icon>autorenew</mat-icon>
      </div>
      <div class="status-title">Field Mapped</div>
      <div *ngIf="isFieldProcessed==true" class="status-text done-text">Done</div>
      <div *ngIf="isFieldProcessed==false" class="status-text progress-text">Pending</div>
    </div>

    <div class="line done-line"></div>

    <div class="status-item">
       <div class="circle done" *ngIf="isReferralProcessed==true">
        <mat-icon>check</mat-icon>
      </div>
       <div class="circle progress" *ngIf="isReferralProcessed==false">
        <mat-icon>autorenew</mat-icon>
      </div>
      <div class="status-title">Qualifying</div>
     <div *ngIf="isReferralProcessed==true" class="status-text done-text">Done</div>
      <div *ngIf="isReferralProcessed==false" class="status-text progress-text">Pending</div>
    </div>

    <div class="line"></div>

    <div class="status-item">
       <div class="circle done" *ngIf="isPromptProcessed==true">
        <mat-icon>check</mat-icon>
      </div>
       <div class="circle progress" *ngIf="isPromptProcessed==false">
        <mat-icon>autorenew</mat-icon>
      </div>
      <div class="status-title">Question</div>
      <div *ngIf="isPromptProcessed==true" class="status-text done-text">Done</div>
      <div *ngIf="isPromptProcessed==false" class="status-text progress-text">Pending</div>
    </div>

  </div> 

 <p class="status-header">
  <span class="section-title1">AI Automation Process Status:</span>
  <strong *ngIf="aiAutomationProcessStatus == 1">Running</strong>
  <strong *ngIf="aiAutomationProcessStatus == 2">Completed</strong>
</p>

</div>